import { connect } from 'react-redux';

import { RegistrationModal } from './RegistrationModal';
import type { Dispatch } from 'redux';

import type { Vehicle } from '@cobliteam/common-types';

import type { MaintenanceOption, PastMaintenance, RegisterPastMaintenance, ReminderPrefill, WebData } from '@cobliteam/api-lib';

import type { MaintenanceState } from '../../store/maintenanceStore';
import {
  deleteMaintenanceRequest,
  loadMaintenanceItemOptionsRequest,
  saveMaintenanceMarkedAsDoneRequest,
  saveMaintenanceRegistryRequest,
} from '../../store/RegisterMaintenance/actionCreators';
import { selectEditMaintenance, selectMaintenanceItemOptions, selectReminderPrefill } from '../../store/RegisterMaintenance/selectors';

interface OwnProps {
  vehiclesWebData: WebData<Vehicle[]>;
  onClose: () => void;
}

interface StateProps {
  maintenanceItemOptionsWebData: WebData<MaintenanceOption[]>;
  editMaintenance?: PastMaintenance;
  reminderPrefill?: ReminderPrefill;
}

interface DispatchProps {
  onSaveClick: (maintenance: RegisterPastMaintenance, isFromWarning: boolean) => void;
  onDeleteMaintenance: (maintenance: PastMaintenance) => void;
  onLoadItems: () => void;
}

const mapStateToProps = (state: MaintenanceState): StateProps => ({
  maintenanceItemOptionsWebData: selectMaintenanceItemOptions(state),
  editMaintenance: selectEditMaintenance(state),
  reminderPrefill: selectReminderPrefill(state),
});

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps): DispatchProps => ({
  onSaveClick: (maintenance, isFromWarning) => {
    if (isFromWarning) {
      dispatch(saveMaintenanceMarkedAsDoneRequest(maintenance));
    } else {
      dispatch(saveMaintenanceRegistryRequest(maintenance));
    }
    ownProps.onClose();
  },
  onDeleteMaintenance: (maintenance) => {
    dispatch(deleteMaintenanceRequest(maintenance));
    ownProps.onClose();
  },
  onLoadItems: () => dispatch(loadMaintenanceItemOptionsRequest()),
});

export const RegistrationModalContainer = connect<StateProps, DispatchProps, OwnProps, MaintenanceState>(mapStateToProps, mapDispatchToProps)(RegistrationModal);
